// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_aw-2";
export var aiChatCartContainerExit = "_aw-4";
export var aiChatContainerLarge = "_aw-0";
export var aiChatContainerSmall = "_aw-1";
export var aiChatIcon = "_aw-6";
export var slideInFromRight = "_aw-3";
export var slideOutToRight = "_aw-5";